export default __webpack_public_path__ + "static/media/javascript.4c1b5332.svg";